export default __webpack_public_path__ + "static/media/bell.c9e24294.svg";